/**
 * Shared color tokens for the SensorAlertSection feature (spec 043).
 *
 * The legacy app does not centralize design tokens in the Chakra theme yet,
 * so these constants mirror the Figma palette used across the section
 * (Editar seleção button, tab strip, lightning + rain configuration cards).
 *
 * Single source of truth — refactor here and the entire section updates.
 */

export const SA_COLORS = {
  /** Primary blue used by accents, active states, links, icons. */
  primary: "#0884CC",
  /** Subtle primary fill — active toggle bg, gateway entry button. */
  primarySubtleBg: "rgba(183, 227, 252, 0.32)",
  /** Slightly stronger primary fill — hover on subtle backgrounds. */
  primarySubtleBgHover: "rgba(183, 227, 252, 0.5)",
  /** Border color for the gateway "Editar seleção" entry. */
  primaryBorder: "#93D5FB",
  /** Tab counter pill bg when active. */
  primaryCounterBg: "#DBF1FE",
  /** Title text color (panel headings). */
  textTitle: "#242E38",
  /** Body / hint text color (subtitles, descriptions). */
  textBody: "#4A6075",
  /** Inactive tab label color. */
  textTabInactive: "#57708A",
  /** Form label color (e.g. "Receba atualizações a cada"). */
  textFormLabel: "#414651",
  /** Default panel border (lightning configuration card). */
  panelBorder: "#B9C6D3",
  /** Tab strip bottom border. */
  tabStripBorder: "#E4E4E7",
} as const;
